import classNames from 'classnames/bind';
import styles from './RecruitBanner.module.css';

const cx = classNames.bind(styles);

interface IRecruitBannerProps {
  image: string;
  title: string;
  description: string;
}

function RecruitBanner({ image, title, description }: IRecruitBannerProps) {
  return (
    <section
      className={cx('banner')}
      style={{ backgroundImage: `url(${image})` }}
    >
      <div className={cx('inner')}>
        <h1 className={cx('title')}>{title}</h1>
        <p className={cx('description')}>{description}</p>
      </div>
    </section>
  );
}

export default RecruitBanner;
